import ButtonContainer from "@components/ButtonContainer";
import TextEditorTwo from "@components/EasyDev/text-editor/TextEditor";
import FormTextField from "@components/Shared/FormTextField";
import IFaq from "@interfaces/faq";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";

interface IModifyForm extends IFormProps {
  data: IFaq;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => (
  <form className="form form--horizontal" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label">Question</span>
      <div className="form__form-group-field">
        <Field
          name="question"
          component={FormTextField}
          type="text"
          placeholder={"Enter a Question"}
          initialValue={data?.question}
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Answer</span>
      <div className="form__form-group-field">
        <Field
          name="answer"
          component={TextEditorTwo}
          initialValue={data?.answer}
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Order</span>
      <div className="form__form-group-field">
        <Field
          name="order"
          component={FormTextField}
          type="number"
          initialValue={data?.order}
          isAboveError
        />
      </div>
    </div>

    <ButtonContainer />
  </form>
);

export default ModifyForm;
